import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cb3eaf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "periodontal-map-table__columns" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick", "onMouseover"]
const _hoisted_7 = ["onClick", "onMouseover"]
const _hoisted_8 = ["onClick", "onMouseover"]
const _hoisted_9 = {
  key: 1,
  class: "periodontal-map-table__recession"
}
const _hoisted_10 = {
  key: 2,
  class: "periodontal-map-table__sounding"
}
const _hoisted_11 = {
  key: 3,
  class: "periodontal-map-table__sounding"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 0 }

import {
  computed,
  onMounted,
  PropType,
  ref,
} from 'vue'
import { useRoute } from 'vue-router'
import {
  getNextInputIndexByArrow,
  getTabDirection,
  removeSelectionRanges,
} from '@/entities/EPeriodontalMapTable/utils/periodontalMap'
import {
  DirectionType,
  PeriodontalParameterType,
} from '@/entities/EPeriodontalMapTable/types/periodontalMap.type'
import { PeriodontalDataType } from '@/shared/types'
import { TEETH_STATUSES } from '@/shared/constants'


export default /*#__PURE__*/_defineComponent({
  props: {
  isPdfMode: Boolean,
  isReverse: Boolean,
  isInteractive: Boolean,
  columns: Array as PropType<PeriodontalDataType[]>,
},
  emits: [
  'recession',
  'reset',
  'change-status',
  'plaque',
  'bleeding',
  'suppuration',
  'furation',
  'mobility',
  'sounding',
],
  setup(__props, { emit }) {

const props = __props





const route = useRoute()

const recessionInputs = ref<HTMLInputElement[]>([])
const soundingInputs = ref<HTMLInputElement[]>([])

const LEGENDS = [
  'Подвижность (0-3)',
  'Фуркация (0-3)',
  'Зубной налёт',
  'Кровоточивость',
  'Гноетечение',
  'Рецессия',
  'Гл. зондирования',
]

const isPreviewMode = computed(() => route.query['view-mode'] === '1')
const periodontalMapData = computed((): PeriodontalDataType[] => props.columns)

const handleClickColumn = (event: MouseEvent, columnId: number): void => {
  if (event.shiftKey) {
    removeSelectionRanges()
    emit('reset', columnId)
  } else {
    emit('change-status', columnId)
  }
}

const handleChangePeriodontalParameter = (
  parameter: PeriodontalParameterType,
  columnId: number,
  parameterId: number
): void => {
  removeSelectionRanges()
  emit(parameter, columnId, parameterId)
}

const handleChangeFuration = (columnId: number, furationId: number): void => {
  emit('furation', columnId, furationId)
}

const handleChangeMobility = (columnId: number): void => {
  emit('mobility', columnId)
}

const handleFocusOutRecession = (
  columnId: number,
  recessionId: number,
  value: number
) => {
  if (typeof value === 'string') {
    emit('recession', columnId, recessionId, 0)
    return
  }
}

const handleInputRecession = (
  columnId: number,
  recessionId: number,
  value: number
): void => {
  const CHAR_MINUS = '-'

  if (!value) return
  if (typeof value === 'string' && value !== CHAR_MINUS) {
    emit('recession', columnId, recessionId, 0)
    return
  }

  if (value > 20) {
    emit('recession', columnId, recessionId, 20)
  } else if (value < -20) {
    emit('recession', columnId, recessionId, -20)
  } else {
    emit('recession', columnId, recessionId, value)
  }
}

const handleInputSounding = (
  columnId: number,
  soundingId: number,
  value: number
): void => {
  if (!+value) {
    emit('sounding', columnId, soundingId, 0)

    return
  }

  if (+value > 20) {
    emit('sounding', columnId, soundingId, 20)
  } else if (+value < 0) {
    emit('sounding', columnId, soundingId, 0)
  } else {
    emit('sounding', columnId, soundingId, +value)
  }
}

const handleChangeInputByArrows = (
  currentInput: KeyboardEvent,
  inputs: HTMLInputElement[],
  direction: DirectionType
): void => {
  const currentInputId = (currentInput.target as Element).id
  const nextIndex = getNextInputIndexByArrow(inputs, currentInputId, direction)

  inputs[nextIndex].focus()
}

const handleChangeInputByTab = (
  currentInput: KeyboardEvent,
  inputs: HTMLInputElement[]
): void => {
  const currentInputId = (currentInput.target as HTMLInputElement).id

  const tabDirection = getTabDirection(currentInputId, inputs)

  const nextIndex = getNextInputIndexByArrow(
    inputs,
    currentInputId,
    tabDirection
  )
  inputs[nextIndex].focus()
}

onMounted((): void => {
  recessionInputs.value = [
    ...document.querySelectorAll('.periodontal-map-table__recession-item'),
  ].map((input) => input.children[0].children[0]) as HTMLInputElement[]

  soundingInputs.value = [
    ...document.querySelectorAll('.periodontal-map-table__sounding-item'),
  ].map((input) => input.children[0].children[0]) as HTMLInputElement[]
})

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
      'periodontal-map-table--reverse': __props.isReverse,
      'periodontal-map-table--preview': _unref(isPreviewMode) || __props.isPdfMode,
      'periodontal-map-table--interactive': __props.isInteractive,
    }, "periodontal-map-table"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'periodontal-map-table__legends--interactive': __props.isInteractive,
        'periodontal-map-table__legends--preview': _unref(isPreviewMode) || __props.isPdfMode,
      }, "periodontal-map-table__legends"])
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(LEGENDS, (legend) => {
        return _createElementVNode("p", {
          class: _normalizeClass([{
          'periodontal-map-table__legend--preview': _unref(isPreviewMode) || __props.isPdfMode,
          'periodontal-map-table__legend--interactive': __props.isInteractive,
        }, "periodontal-map-table__legend"])
        }, _toDisplayString(legend), 3)
      }), 64))
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(periodontalMapData), (column) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([{
          'periodontal-map-table__column--preview': _unref(isPreviewMode) || __props.isPdfMode,
          'periodontal-map-table__column--hidden':
            column.statusCode === _unref(TEETH_STATUSES).removed,
          'periodontal-map-table__column--interactive': __props.isInteractive,
        }, "periodontal-map-table__column"])
        }, [
          (!__props.isReverse)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([{
            'periodontal-map-table__column-header--interactive': __props.isInteractive,
            'periodontal-map-table__column-header--removed':
              column.statusCode === _unref(TEETH_STATUSES).removed,
          }, "periodontal-map-table__column-header"]),
                onClick: ($event: any) => (handleClickColumn($event, column.number))
              }, [
                (column.statusCode !== _unref(TEETH_STATUSES).removed)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(column.number), 1))
                  : (_openBlock(), _createBlock(_component_icon_template, {
                      key: 1,
                      class: "periodontal-map-table__column-header-icon",
                      height: "12",
                      name: "removed",
                      width: "12"
                    }))
              ], 10, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass([{
            'periodontal-map-table__column-content--hidden':
              column.statusCode === _unref(TEETH_STATUSES).removed,
            'periodontal-map-table__column-content--interactive': __props.isInteractive,
          }, "periodontal-map-table__column-content"])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([{
              'periodontal-map-table__mobility--preview': _unref(isPreviewMode),
              'periodontal-map-table__mobility--pdf': __props.isPdfMode,
              'periodontal-map-table__mobility--interactive': __props.isInteractive,
            }, "periodontal-map-table__mobility"]),
              onClick: ($event: any) => (handleChangeMobility(column.number))
            }, _toDisplayString(column.mobility), 11, _hoisted_4),
            _createElementVNode("div", {
              class: _normalizeClass([{
              'periodontal-map-table__furation-wrapper--double':
                column.furation.length === 2,
              'periodontal-map-table__furation-wrapper--hidden':
                column.statusCode === _unref(TEETH_STATUSES).implant,
              'periodontal-map-table__furation-wrapper--interactive':
                __props.isInteractive,
            }, "periodontal-map-table__furation-wrapper"])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.furation, (furation, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                'periodontal-map-table__furation--preview': _unref(isPreviewMode),
                'periodontal-map-table__furation--pdf': __props.isPdfMode,
                'periodontal-map-table__furation--interactive': __props.isInteractive,
              }, "periodontal-map-table__furation"]),
                  onClick: ($event: any) => (handleChangeFuration(column.number, index))
                }, _toDisplayString(furation), 11, _hoisted_5))
              }), 256))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([{
              'periodontal-map-table__plaque--interactive': __props.isInteractive,
            }, "periodontal-map-table__plaque"])
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
                return _createElementVNode("div", {
                  class: _normalizeClass([{
                'periodontal-map-table__plaque-item--disabled':
                  !column.plaque[index],
                'periodontal-map-table__plaque-item--preview':
                  _unref(isPreviewMode) || __props.isPdfMode,
                'periodontal-map-table__plaque-item--interactive':
                  __props.isInteractive,
              }, "periodontal-map-table__plaque-item"]),
                  onClick: ($event: any) => (
                handleChangePeriodontalParameter('plaque', column.number, index)
              ),
                  onMouseover: _withModifiers(($event: any) => (
                handleChangePeriodontalParameter('plaque', column.number, index)
              ), ["shift"])
                }, null, 42, _hoisted_6)
              }), 64))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([{
              'periodontal-map-table__bleeding--interactive': __props.isInteractive,
            }, "periodontal-map-table__bleeding"])
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
                return _createElementVNode("div", {
                  class: _normalizeClass([{
                'periodontal-map-table__bleeding-item--disabled':
                  !column.bleeding[index],
                'periodontal-map-table__bleeding-item--preview':
                  _unref(isPreviewMode) || __props.isPdfMode,
                'periodontal-map-table__bleeding-item--interactive':
                  __props.isInteractive,
              }, "periodontal-map-table__bleeding-item"]),
                  onClick: ($event: any) => (
                handleChangePeriodontalParameter(
                  'bleeding',
                  column.number,
                  index
                )
              ),
                  onMouseover: _withModifiers(($event: any) => (
                handleChangePeriodontalParameter(
                  'bleeding',
                  column.number,
                  index
                )
              ), ["shift"])
                }, null, 42, _hoisted_7)
              }), 64))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([{
              'periodontal-map-table__suppuration--interactive': __props.isInteractive,
            }, "periodontal-map-table__suppuration"])
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
                return _createElementVNode("div", {
                  class: _normalizeClass([{
                'periodontal-map-table__suppuration-item--disabled':
                  !column.suppuration[index],
                'periodontal-map-table__suppuration-item--preview':
                  _unref(isPreviewMode) || __props.isPdfMode,
                'periodontal-map-table__suppuration-item--interactive':
                  __props.isInteractive,
              }, "periodontal-map-table__suppuration-item"]),
                  onClick: ($event: any) => (
                handleChangePeriodontalParameter(
                  'suppuration',
                  column.number,
                  index
                )
              ),
                  onMouseover: _withModifiers(($event: any) => (
                handleChangePeriodontalParameter(
                  'suppuration',
                  column.number,
                  index
                )
              ), ["shift"])
                }, null, 42, _hoisted_8)
              }), 64))
            ], 2),
            (__props.isInteractive)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([{
              'periodontal-map-table__recession--interactive': __props.isInteractive,
            }, "periodontal-map-table__recession"])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.recession, (recessionItem, index) => {
                    return (_openBlock(), _createBlock(_component_el_input, {
                      key: index,
                      modelValue: column.recession[index],
                      "onUpdate:modelValue": ($event: any) => ((column.recession[index]) = $event),
                      modelModifiers: { number: true },
                      class: "periodontal-map-table__recession-item",
                      maxlength: "3",
                      onFocusout: ($event: any) => (
                handleFocusOutRecession(
                  column.number,
                  index,
                  column.recession[index]
                )
              ),
                      onInput: ($event: any) => (
                handleInputRecession(
                  column.number,
                  index,
                  column.recession[index]
                )
              ),
                      onKeydown: [
                        _cache[0] || (_cache[0] = _withKeys(($event: any) => (
                handleChangeInputByArrows($event, recessionInputs.value, 'left')
              ), ["left"])),
                        _cache[1] || (_cache[1] = _withKeys(($event: any) => (
                handleChangeInputByArrows($event, recessionInputs.value, 'right')
              ), ["right"])),
                        _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (
                handleChangeInputByTab($event, recessionInputs.value)
              ), ["prevent"]), ["tab"]))
                      ]
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocusout", "onInput"]))
                  }), 128))
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.recession, (recessionItem, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(recessionItem), 1))
                  }), 128))
                ])),
            (__props.isInteractive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.sounding, (soundingItem, index) => {
                    return (_openBlock(), _createBlock(_component_el_input, {
                      key: index,
                      modelValue: column.sounding[index],
                      "onUpdate:modelValue": ($event: any) => ((column.sounding[index]) = $event),
                      class: _normalizeClass([{
                'periodontal-map-table__sounding-danger': soundingItem >= 4,
              }, "periodontal-map-table__sounding-item"]),
                      max: "20",
                      maxlength: "3",
                      type: "number",
                      onInput: ($event: any) => (
                handleInputSounding(
                  column.number,
                  index,
                  column.sounding[index]
                )
              ),
                      onKeydown: [
                        _cache[3] || (_cache[3] = _withKeys(($event: any) => (
                handleChangeInputByArrows($event, soundingInputs.value, 'left')
              ), ["left"])),
                        _cache[4] || (_cache[4] = _withKeys(($event: any) => (
                handleChangeInputByArrows($event, soundingInputs.value, 'right')
              ), ["right"])),
                        _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (
                handleChangeInputByTab($event, soundingInputs.value)
              ), ["prevent"]), ["tab"]))
                      ]
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "onInput"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.sounding, (soundingItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass({
                'periodontal-map-table__sounding-danger': soundingItem >= 4,
              })
                    }, _toDisplayString(soundingItem), 3))
                  }), 128))
                ]))
          ], 2),
          (__props.isReverse)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([{
            'periodontal-map-table__column-header--interactive': __props.isInteractive,
            'periodontal-map-table__column-header--removed':
              column.statusCode === _unref(TEETH_STATUSES).removed,
          }, "periodontal-map-table__column-header"]),
                onClick: ($event: any) => (handleClickColumn($event, column.number))
              }, [
                (column.statusCode !== _unref(TEETH_STATUSES).removed)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(column.number), 1))
                  : (_openBlock(), _createBlock(_component_icon_template, {
                      key: 1,
                      class: "periodontal-map-table__column-header-icon",
                      height: "12",
                      name: "removed",
                      width: "12"
                    }))
              ], 10, _hoisted_12))
            : _createCommentVNode("", true)
        ], 2))
      }), 256))
    ])
  ], 2))
}
}

})